import React from 'react'
import './Vision.css'


function Vision() {
    return (
        <div className='wrapper'>
            <h1>Our Vision</h1>
            <div className='vision-container'>
                <div className='image-container'>
                    <img src='/images/chakra.png' className='chakra' alt='chakra'/>
                    <h3>एकं॒ सद्विप्रा॑ बहु॒धा व॑दन्त्य॒ग्निं य॒मं मा॑त॒रिश्वा॑नमाहुः</h3>
                </div>
                <div className="text-container">
                    <img className='pen' src='/images/pen.png' alt='pen'/>
                    <div className='text-1'>
                        <h3>But why history?</h3>
                        <p>
                        The term history is derived from the Greek word 'historia' 
                        meaning inquiry and hence History is defined as 'the scientific 
                        study of the past'. History helps us to understand the ways of 
                        human society extending to fields like science, technology, sports 
                        and even modern-day politics. The understanding of these fields in 
                        turn equip us with the knowledge that impacts our future.
                        Understading History gives one an opportunity to learn about 
                        the mistakes incurred by our ancestors, and study their solutions 
                        in order to build a better future. History also fosters within 
                        us national pride, unity and identity!
                        </p>
                    </div>
                    <div className='text-2'>
                    <h3>Philosophy seems like boring old man's tale. Why would it be interesting?</h3>
                    <p>
                        Philosophy is the central element of history of many civilisations. 
                        In a broad sense, philosophy is an activity people undertake when 
                        they seek to understand fundamental truths about themselves, the 
                        world in which they live, and their relationships to the world and 
                        to each other.The aim in Philosophy is not to master a body of facts, 
                        so much as think clearly and sharply through any set of facts.
                    </p>
                    </div>
                    <div className='text-3'>
                    <h3>Culture is nothing but an outdated set of ideas, right? Wrong!</h3>
                    <p>
                    Culture is a set of shared collective human beliefs, practices, 
                    and behaviour of a particular social or ethnic group, influenced 
                    by their history, location and time period. We in turn use culture 
                    to adapt and transform the world we live in.

                    Culture is is transmitted from on generation to another, 
                    establishing a style of behaviour.We have in our culture 
                    in terms of values, ideas, attitudes, symbols, artifacts, 
                    or other, and we are likely to conform to those. Apart from 
                    providing an identity, culture provides us with a way of life 
                    and oneness to a collective principle helping us be part of a 
                    greater cause!
                    </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Vision
